import { useIsFrontendStyleRed } from '#base/hooks';

const useVariantByStyle = () => {
  const isFrontendStyleRed = useIsFrontendStyleRed();

  return <T>(variantForDefault: T, variantForRed: T): T => {
    if (isFrontendStyleRed) {
      return variantForRed;
    }
    return variantForDefault;
  };
};

export { useVariantByStyle };
